<template>
    <div class="task-dot-drop-menu" @click="clickEvent" @mouseenter="mouseEvent" @mouseleave="mouseEvent">
        <span >
            <img :src="dotImg" />
        </span>
        <transition name="fade"> 
            <slot v-if="show"></slot>
        </transition> 
    </div>
</template>
<script>
export default {
    data () {
        return {
            show: 0,
            dotImg: require('@/assets/img/icon/dot_task.svg'),
        }
    },
    mounted() {
        let _this = this;
        let el = _this.$el;
        document.addEventListener('click', function (e) {
            // console.log(e.target != el)
            if( el.contains(e.target) != true){
                _this.dropUp();
            }
        })
    },
    methods: {
        dropDown: function () {
            this.show = !this.show;
        },
        dropUp: function () {
            this.show = 0;
        },
        clickEvent: function () {
            let tag = event.target.tagName;
            // console.log(tag)
            if( tag == 'LI' ){
                this.dropUp();
            }else if( tag == 'DIV' || tag == 'SPAN' || tag == 'IMG'){
                this.dropDown()
            }
        },
        mouseEvent: function () {
            // console.log(event)
           
        }
    }
}
</script>
<style   lang="scss">
    .task-dot-drop-menu{
        position: relative;
        width: 44px;
        height: 44px;
        border-radius: 4px;
        cursor: pointer;
        ul{
            position: absolute;
            width: 187px;
            padding: 4px 0;
            border-radius: 4px;
            background: #f0f0f0;
            top: 44px;
            right: 0;
            border: solid 1px #eeeeee;
            box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
            z-index: 6;
            li{
                position: relative;
                padding: 12px 25px;
                display: flex;
                align-items: center;
                cursor: pointer;
            }
            li:hover{
                background: #fff;
            }
        }
    }
   
</style>


// WEBPACK FOOTER //
// src/components/widge/TaskDotDropMenu.vue